import PlayIcon from './play-icon';

export default PlayIcon;
export { PlayIcon };